import React from 'react'
import {useApolloQuery as useQuery} from 'apollo-hooks'
import gql from 'graphql-tag'
import get from 'lodash/get'

import styles from './styles.module.css'

export default function LegalInformation({storeId}) {
  const {store} = useQuery({
    query: gql`
      query getStoreInvoiceReceiver($storeId: ID) {
        store(storeId: $storeId) {
          invoiceReceiver {
            legalIdentifier
            invoiceInformation
          }
          address {
            fullAddress
          }
        }
      }
    `,
    variables: {storeId},
    fetchPolicy: 'cache-first'
  })

  return (
    <div className={styles.legalInformation}>
      <div>Razón Social:</div>
      <div>{get(store, 'invoiceReceiver.invoiceInformation.legalName', '')}</div>
      <div>RUC:</div>
      <div>{get(store, 'invoiceReceiver.legalIdentifier', '')}</div>
      <div>Dirección:</div>
      <div>{get(store, 'address.fullAddress', '')}</div>
    </div>
  )
}
